"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Carousel = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react2 = require("swiper/react");
var _swiper = require("swiper");
require("swiper/css");
require("swiper/css/pagination");
require("swiper/css/navigation");
require("swiper/css/autoplay");
var _CarouselModule = _interopRequireDefault(require("./Carousel.module.css"));
require("./overrides.css");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var Carousel = function Carousel(_ref) {
  var _items = _ref.items,
    height = _ref.height,
    fade = _ref.fade,
    fadeColor = _ref.fadeColor,
    autoPlay = _ref.autoPlay,
    pauseOnHover = _ref.pauseOnHover,
    interval = _ref.interval,
    initialSlide = _ref.initialSlide,
    loop = _ref.loop,
    showArrows = _ref.showArrows,
    _onClick = _ref.onClick;
  var items = (0, _react.useMemo)(function () {
    return (_items || []).map(function (itm, index) {
      if ((itm === null || itm === void 0 ? void 0 : itm.item_name.indexOf('video')) > -1 && (itm === null || itm === void 0 ? void 0 : itm.template.indexOf('iframe')) > -1) {
        return _objectSpread(_objectSpread({}, itm), {}, {
          contentClass: 'slider-iframe-video'
        });
      }
      return itm;
    });
  }, [_items]);

  // useEffect(() => {
  //   items.forEach((item, index) => {
  //      if(item?.item_name.indexOf('video') > -1 && item?.template.indexOf('iframe') > -1){
  //       return {
  //          ...item,
  //         contentClass:'slider-iframe-video'
  //        }
  //      }
  //   });
  // }, []);

  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_CarouselModule.default.container, 'carousel-wrapper', fade && 'carousel-fade'),
    style: {
      '--height': height
    }
  }, /*#__PURE__*/_react.default.createElement(_react2.Swiper, {
    initialSlide: initialSlide ? initialSlide : 0,
    slidesPerView: 1,
    spaceBetween: 0,
    loop: (items === null || items === void 0 ? void 0 : items.length) > 1 && loop,
    pagination: {
      clickable: true
    },
    navigation: showArrows,
    autoplay: autoPlay ? {
      delay: interval,
      disableOnInteraction: pauseOnHover
    } : false,
    modules: [_swiper.Pagination, _swiper.Navigation, _swiper.Autoplay],
    className: (0, _classnames.default)(_CarouselModule.default.carousel, fade && _CarouselModule.default.fade),
    touchMoveStopPropagation: true
  }, items === null || items === void 0 ? void 0 : items.map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement(_react2.SwiperSlide
    /*virtualIndex={index}*/, {
      key: item.id ? item.id : index,
      className: _CarouselModule.default.item,
      onClick: function onClick() {
        if (_onClick) _onClick(item);
      },
      style: _objectSpread({
        backgroundImage: "url(".concat(item.imgUrl, ")"),
        '--fade-color': fadeColor
      }, item.style),
      "data-swiper-autoplay": item.duration
    }, (item === null || item === void 0 ? void 0 : item.content) && /*#__PURE__*/_react.default.createElement("div", {
      className: item === null || item === void 0 ? void 0 : item.contentClass,
      dangerouslySetInnerHTML: {
        __html: item.content
      }
    }));
  })));
};
exports.Carousel = Carousel;
Carousel.propTypes = {
  items: _propTypes.default.array,
  height: _propTypes.default.string,
  fade: _propTypes.default.bool,
  fadeColor: _propTypes.default.string,
  autoPlay: _propTypes.default.bool,
  interval: _propTypes.default.number,
  loop: _propTypes.default.bool
};
Carousel.defaultProps = {
  /*items: [
    {
      imgUrl:
        'https://staticdata.lider-bet.com/images/banners/627dbcb24e6f70cf1bff2ce0aa248488/egtcashback-21-03-GE.jpg?12',
      to: '#',
    },
    {
      imgUrl:
        'https://staticdata.lider-bet.com/images/banners/2c115564608c64faf47426ca12fabdc8/20home-GE.jpg',
      to: '#',
    },
    {
      imgUrl:
        'https://staticdata.lider-bet.com/images/banners/4f70ea2bfe93e11a87caabf39b4f96ec/luckyautumn-GE.jpg',
      to: '#',
    },
  ],*/
  height: '29vw',
  fade: true,
  fadeColor: '#16171a',
  autoPlay: true,
  pauseOnHover: false,
  interval: 6000,
  loop: true,
  showArrows: false
};